export const BASE_URL = "https://comprartodo.com/api";